const ObjectUtil = require('@core/util/object');
const removeExtension = require('./removeExtension');

module.exports = (product, meta) => {
  const {
    identifier: { productId },
    traits: { colors: { selectedColor } },
    relationships,
    imagery: { primaryImage: { filePath } },
  } = product;

  const modelId = ObjectUtil.getChildProperty(meta, 'analytics.coremetrics.modelId') || 'pros';

  const categoryId = ObjectUtil.getChildProperty(relationships, 'taxonomy.defaultCategoryId') || '';

  const imageId = removeExtension((ObjectUtil.getChildProperty(selectedColor, 'imagery.primaryImage.filePath') || filePath));

  return `/shop/similar-products?productId=${productId}&imageId=${imageId}&CategoryID=${categoryId}&modelId=${modelId}&cm_sp=MLT_RESP-_-${modelId}-_-${imageId}_${productId}`;
};
